import templateUrl from "emun.order/order-notes-popup.htm";
import OrderNotesPopupController from "emun.order/order-notes-popup.controller";
import open from "webmodals/open";

let OrderNotesPopup = options => {
  let modalInstance = open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
    controller: OrderNotesPopupController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default OrderNotesPopup;
